import { TreatmentDemoVideoStatus } from '../model';

export const getTreatmentDemoVideoStatusText = (value?: TreatmentDemoVideoStatus | null): string => {
    switch (value) {
        case TreatmentDemoVideoStatus.pendingAssign:
            return '剪辑:待分配';
        case TreatmentDemoVideoStatus.pendingUpload:
            return '剪辑:待上传';
        case TreatmentDemoVideoStatus.uploaded:
            return '剪辑:已上传';
        case TreatmentDemoVideoStatus.skipped:
            return '剪辑:已跳过';
        default:
            return '';
    }
};
